module.exports = __webpack_public_path__ + "images/pornographer-ff4bd66e42c0bfa64ccda73ea877a83b.png";